export const ESTADOS_QR = Object.freeze({ no_usada: 'No usada', usada: 'Usada', anulada: 'Anulada', bloqueada: 'Bloqueada' });
